export const blogItems =[
        {
          img: "assets/Images/blog1.jpg",
          title: "E-commerce Website",
          date: "Aug 2024",
        },
        {
          img: "assets/Images/blog2.jpg",
          title: "Web Development Trends",
          date: "Aug 2024",
        },
        {
          img: "assets/Images/blog3.jpg",
          title: "Mobile App Development",
          date: "Aug 2024",
        },
        {
          img: "assets/Images/blog4.jpg",
          title: "UI/UX Design",
          date: "Aug 2024",
        },
        {
          img: "assets/Images/blog5.jpg",
          title: "Artificial Intelligence",
          date: "Sep 2024",
        },
        {
          img: "assets/Images/blog6.jpg",
          title: "Cybersecurity",
          date: "Sep 2024",
        }
]

export const serviceItem = [
    {
        img: "assets/Images/ui-ux.png",
        title: "UI-UX Design",
        desc: "I craft intuitive and visually stunning user interfaces that elevate user experiences. "
    },
    {
        img: "assets/Images/app-development.png",
        title: "Mobile Development",
        desc: "I design and user-friendly mobile apps that drive engagement and conversion. "
    },
    {
        img: "assets/Images/web-development.png",
        title: "Web Development",
        desc: "I build fast, secure, and scalable web applications that drive business growth. "
    },
    {
        img :"assets/Images/digital.png",
        title :"Digital Marketing",
        desc:"Grow your business & sales — Improve visibility for your brand and products."

    },
    {
        img :"assets/Images/server.png",
        title :"Server Maintenance",
        desc:"A series of regular tasks that ensure a server is running smoothly, securely, and efficiently."
    },
    {
        img :"assets/Images/game.png",
        title :"Game development",
        desc:"Creating games and describes the design, development and release of a game."
    }
]


export const portfolioitem = [
    {
      img: "assets/Images/homepage1.png",
      name: "Website Redesign",
      tagline: "Modern and responsive design for better user experience.",
      class: "web"
    },
    {
      img: "assets/Images/homepage2.jpg",
      name: "Mobile App Development",
      tagline: "Creating intuitive and fast mobile apps for Android and iOS.",
      class: "mobile"
    },
    {
      img: "assets/Images/homepage3.jpg",
      name: "UI/UX Design",
      tagline: "Crafting user interfaces that are both functional and beautiful.",
      class: "uiux"
    },
    {
      img: "assets/Images/homepage4.jpg",
      name: "E-commerce Platform",
      tagline: "Build a robust online store with a seamless shopping experience.",
      class: "uiux"
    },
    {
      img: "assets/Images/homepage3.jpg",
      name: "Mobile App for Fitness",
      tagline: "A fitness app designed to track workouts and health metrics.",
      class: "mobile"
    },
    {
      img: "assets/Images/homepage2.jpg",
      name: "Business Website",
      tagline: "A professional website for showcasing your business services.",
      class: "web"
    },
  ];
  

  export const education = [
    {
      title: "Bachelor's in Computer Science",
      institution: "XYZ University",
      year: "2015 - 2019",
      description: "A comprehensive program focused on foundational computer science principles, including algorithms, data structures, programming languages, and software development.",
    },
    {
      title: "Master's in Software Engineering",
      institution: "ABC Institute of Technology",
      year: "2020 - 2022",
      description: "An advanced program that covered software architecture, development methodologies, cloud computing, and team management to prepare for leadership roles in tech development.",
    },
    {
      title: "Web Development Bootcamp",
      institution: "Tech Academy",
      year: "2023",
      description: "A practical, hands-on program designed to teach modern web development technologies such as React.js, Node.js, HTML, CSS, and JavaScript to build full-stack applications.",
    },
  ];
  
  
  export const Experience = [
    {
      title: "Software Developer",
      company: "Tech Solutions Ltd.",
      duration: "2020 - Present",
      description: "Developed and maintained web applications using React and Node.js.",
    },
    {
      title: "Junior Web Developer",
      company: "WebWorks Inc.",
      duration: "2018 - 2020",
      description: "Worked on front-end development with HTML, CSS, and JavaScript for client projects.",
    },
    {
      title: "Intern",
      company: "Code Labs",
      duration: "2017 - 2018",
      description: "Assisted in developing a mobile application using React Native and collaborated with the design team.",
    },
  ];
  


export const skillItem = [
    {
        img: "assets/Images/html5.png",
        title: "HTML 5",
    },
    {
        img: "assets/Images/css3.png",
        title: "CSS 3",
    },
    {
        img: "assets/Images/js.png",
        title: "JS",
    },
    {
        img: "assets/Images/react.png",
        title: "REACT JS",
    },
    {
        img: "assets/Images/php.png",
        title: "PHP",
    },
    {
        img: "assets/Images/nodejs.png",
        title: "NODE JS",
    },
]